/**
 * mwApp.channels module <br>
 * Work with channels: show/add/edit/remove
 *
 * @namespace mwApp/channels
 */

import AiChatController from '../common/components/aiChat/aiChat.controller'
import AddChannelCtrl from './addChannel.controller'
import ChannelsCtrl from './channels.controller'
import channelsConfig from './channels.config'
import AssignContentSetsCtrl from '../common/components/assignContentSets/assignContentSets.controller'

export default
angular.module('mwApp.channels', [])
  .config(channelsConfig)
  .controller('ChannelsCtrl', ChannelsCtrl)
  .controller('AddChannelCtrl', AddChannelCtrl)
  .controller('AssignContentSetsCtrl', AssignContentSetsCtrl)
  .controller('AiChatController', AiChatController)
